import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useFaith } from "@/lib/useFaith";
import { Reveal, Eyebrow } from "./Reveal";
import { DailyVerse, FaithPills } from "./DailyWord";

export const TodayWord = () => {
  const [faith, setFaith] = useFaith();
  return (
    <section id="today" className="relative overflow-hidden bg-[#F4E6DC] py-28 sm:py-36" data-testid="today-word-section">
      <div className="pointer-events-none absolute -right-24 top-10 h-80 w-80 rounded-full bg-[#FDFBF7] opacity-70 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <Reveal><Eyebrow>Today's word</Eyebrow></Reveal>
        <div className="mt-10 grid gap-12 lg:grid-cols-[1.5fr_1fr] lg:items-end">
          <div className="min-h-[220px]"><DailyVerse faith={faith} /></div>
          <Reveal delay={0.1} className="space-y-6">
            <p className="text-base leading-relaxed text-[#5C4A42]">A new verse every morning, from the faith you choose. We'll remember your choice on this device.</p>
            <FaithPills faith={faith} onChange={setFaith} prefix="today-word" />
            <Link to={`/today?faith=${faith}`} data-testid="today-word-open-page-link"
              className="group inline-flex items-center gap-2 rounded-full bg-[#2C221E] px-5 py-3 text-sm font-medium text-[#FBF5EE] transition-colors hover:bg-[#9E4429]">
              Open my daily page
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
